import { executeSoon } from '@streamr/tv-utils';
export function copyToClipboard(text, options = {}) {
    executeSoon(async () => {
        try {
            await navigator.clipboard.writeText(text);
            options.onDone?.();
        }
        catch (error) {
            console.error('Failed to copy URL:', error);
        }
    });
}
